// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"0d2bba54","668":"70561ae3","723":"25847b87","886":"d3145ce1","905":"48fed855","962":"b02938e9"}[chunkId] + ".chunk.css";
};